import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsIssueLayoutRoute: InvariantJiraRoute = {
	name: 'project-settings-classic-issue-layout',
	path: '/plugins/servlet/project-config/:projectKey/issuelayout',
	query: ['screenId'],
	exact: true,
};
